import PrintableInputOutput from './PrintableInputOutput'

export { PrintableInputOutput }
